var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe",attrs:{"src":`https://cats.molit.eu`}})
}
var staticRenderFns = []

export { render, staticRenderFns }